export default __webpack_public_path__ + "static/media/Astro_Neptune_Black.142c6cb3.png";